import { BackendEvent } from "./types/EventSDK";
import {
  closeWebSocketConnection,
  createWebSocketConnection,
} from "./utils/websocketUtils";

export default class EventSDK {
  private readonly url: string;
  private websocket: WebSocket | null;

  constructor(url: string) {
    this.url = url;
    this.websocket = null;
  }

  connect(): void {
    this.websocket = createWebSocketConnection({
      websocketUrl: this.url,
      onOpen: () => {
        console.log("WebSocket connection established.");
      },
      onMessage: (socket, event) => {
        const message = JSON.parse(event.data);
        this.handleMessage(message as BackendEvent);
      },
      onError: (error) => {
        console.error("WebSocket error:", error);
      },
      onClose: () => {
        console.log("WebSocket connection closed.");
        if (this.websocket) {
          this.websocket.close();
          this.websocket = null;
        }
      },
    });
  }

  destroyWebSocketConnection() {
    if (this.websocket) {
      closeWebSocketConnection(this.websocket);
      this.websocket = null;
    }
  }

  private handleMessage(message: BackendEvent): void {
    this.onBackendEventReceived(message);
  }

  onBackendEventReceived(message: BackendEvent): BackendEvent {
    return message;
  }
}
